const REDACTED = '[redacted]';

// Replace every value with a placeholder but keep the key names,
// so you can still see what shape of input was sent.
function maskValues(value: unknown): unknown {
  if (Array.isArray(value)) return value.map(maskValues);
  if (value && typeof value === 'object') {
    return Object.fromEntries(
      Object.entries(value).map(([k, v]) => [k, maskValues(v)])
    );
  }
  return REDACTED;
}

function redactGraphQlVariables(variables: string): string {
  try {
    return JSON.stringify(maskValues(JSON.parse(variables)));
  } catch {
    // Unparseable: don't risk sending anything through
    return REDACTED;
  }
}

export default redactGraphQlVariables;
